import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const ThreeSixtySpin = createSvgIcon(
  <path d="M6.75 13.288c-1.002-.256-1.876-.58-2.587-.948-1.482-.769-1.913-1.53-1.913-2.012 0-.273.123-.624.534-1.044.416-.426 1.072-.86 1.972-1.25 1.796-.776 4.356-1.284 7.242-1.284 2.887 0 5.446.508 7.242 1.285.9.39 1.557.823 1.973 1.249.41.42.533.771.533 1.043 0 .415-.309 1.043-1.41 1.727-1.06.66-2.638 1.22-4.571 1.546l.374 2.219c2.118-.358 4-.992 5.386-1.854 1.346-.837 2.471-2.058 2.471-3.637 0-1.027-.485-1.912-1.175-2.617-.684-.7-1.62-1.28-2.688-1.741-2.14-.925-5.016-1.47-8.135-1.47-3.118 0-5.995.545-8.135 1.47-1.068.462-2.003 1.04-2.688 1.74C.485 8.417 0 9.302 0 10.329c0 1.809 1.463 3.146 3.128 4.01 1.02.528 2.252.956 3.622 1.264V19.5l7.5-4.5-7.5-4.5v2.788Z" />,
  'three sixty spin',
);

export { ThreeSixtySpin };
